module.exports = __webpack_public_path__ + "static/img/MG.ce09050d.png";